import { WP_ROOT } from '../api/constants';

export const stripWPPath = (url) => {
  return url.replace(WP_ROOT, '');
}


// WEBPACK FOOTER //
// ./src/utils/stripWPPath.js